import { RobotOutlined } from '@ant-design/icons'
import { Col, Row, Typography } from 'antd'
import { getNs } from 'common/i18n-config'

import { Card, CardIcon } from '../styles'
import { Suggestion } from '../types'
import { AICardContent } from './ai-card-content'

const { Text, Title } = Typography

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])

type AISubmittedResultProps = {
  suggestions?: Suggestion[]
  imageSrc?: string
  onTryAgain?: () => void
  onReflect?: (suggestion?: Suggestion) => void
}

export const AISubmittedResult = ({ suggestions, imageSrc, onTryAgain, onReflect }: AISubmittedResultProps) => {
  useNsReady()

  return (
    <Card>
      <Row align="middle" justify="space-between" style={{ marginBottom: '24px' }}>
        <Col span={24}>
          <Row align="middle" gutter={12}>
            <Col>
              <CardIcon>
                <RobotOutlined style={{ fontSize: '16px', color: 'white' }} />
              </CardIcon>
            </Col>
            <Col>
              <div>
                <Title level={5}>{t('ai_analysis_result')}</Title>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {t('ai_analysis_result_description')}
                </Text>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {suggestions?.map(item => {
        return (
          <AICardContent
            key={item.asset_category_code}
            data={item}
            imageSrc={imageSrc}
            onTryAgain={onTryAgain}
            onReflect={onReflect}
          />
        )
      })}
    </Card>
  )
}
